// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyD5vD3wl9BNd9dv999Yx9zplKmdCFyEX1U",
    authDomain: "thriftlo.com",
    projectId: "secondsearch-f34fb",
    storageBucket: "secondsearch-f34fb.appspot.com",
    messagingSenderId: "91951762092",
    appId: "1:91951762092:web:f266712fcb3686dacf083",
    measurementId: "G-1SWKPWGWZP"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Note: Analytics is initialized separately in utils/analytics.js
// only after user consent is obtained